"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _content = _interopRequireDefault(require("./old/content"));

var _dataTypes = _interopRequireDefault(require("./old/dataTypes"));

var _isRelevant = _interopRequireDefault(require("./old/isRelevant"));

var _index = _interopRequireDefault(require("./index"));

var _defaultStyles = _interopRequireDefault(require("../common/defaultStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mergedSettings = Object.keys(_isRelevant["default"]).reduce(function (obj, styleParam) {
  var _objectSpread2;

  var settingsData = _index["default"][styleParam] || _objectSpread({
    isRelevant: _isRelevant["default"][styleParam]
  }, _content["default"][styleParam], {}, _dataTypes["default"][styleParam], {
    "default": _defaultStyles["default"][styleParam],
    isOld: true
  });

  return _objectSpread({}, obj, (_objectSpread2 = {}, _objectSpread2[styleParam] = settingsData, _objectSpread2));
}, {});
var _default = mergedSettings;
exports["default"] = _default;